import { useEffect, useState } from "react";
import { toast } from "sonner";
import { ShieldCheck, Loader2 } from "lucide-react";
import { Button } from "./ui/button";
import { api } from "../lib/api";

export const SalaryDraftsBar = ({ month, onPublished }) => {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (month) api.salaryTargetDrafts(month).then(setD).catch(() => setD(null)); }, [month, onPublished]);
  if (!d?.count) return null;
  const publish = async () => {
    if (!window.confirm(`اعتماد ونشر رواتب ${d.count} مندوب لشهر ${month}؟ ستظهر لهم في البوابة.`)) return;
    setBusy(true);
    try { const r = await api.salaryTargetPublish(month); toast.success(`تم نشر ${r.published} راتب${r.journal_number ? ` وإنشاء قيد الاستحقاق ${r.journal_number}` : ""}`); if (r.journal_error) toast.warning(`لم يُرحّل قيد الرواتب: ${r.journal_error}`); setD(null); onPublished?.(); }
    catch (e) { toast.error(e?.response?.data?.detail || "تعذّر النشر"); } finally { setBusy(false); }
  };
  return (
    <div className="flex flex-wrap items-center justify-between gap-2 rounded-2xl border border-amber-200 bg-amber-50 p-3" data-testid="salary-drafts-bar">
      <p className="text-sm text-amber-900"><b data-testid="salary-drafts-count">{d.count}</b> راتب محسوب تلقائياً بانتظار الاعتماد (إجمالي الصافي {Number(d.total_net).toLocaleString("en")} ر.س) — لا تظهر للمناديب حتى تعتمدها</p>
      <Button size="sm" disabled={busy} onClick={publish} className="gap-1 bg-emerald-600 hover:bg-emerald-700" data-testid="salary-drafts-publish">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <ShieldCheck className="h-4 w-4" />} اعتماد ونشر</Button>
    </div>
  );
};
